(() => {
// Variables
const monogramValue = [];

// Elements
const monogramInputs = document.querySelectorAll('.monogram-text-input__field');
const addMonogramBtn = document.querySelector('.js-monogram-add-btn');
const removeMonogramBtn = document.querySelector('.customization-editor__remove-wrapper');
const clearMonogramBtn = document.querySelector('.monogram-text-input__clear');
const monogramPlaceholder = document.querySelector('.customization-editor__preview-chars');
const customizationMonogram = document.querySelector('.customization-monogram');
const customizationPlaceholder = document.querySelector('.customization-monogram__preview-value');
const resetMonogramBtn = document.querySelector('.customization-monogram__preview-link--remove');
const atcForm = document.querySelector('form[data-type="add-to-cart-form"]');
const atcFormMonogram = document.querySelector('[data-monogram-id]');

// Functions
function init() {
  if (monogramInputs.length) {
    monogramInputs.forEach((input, index) => {
      input.addEventListener('input', function() {
        const allowedChars = /[^a-zA-Z&\-.]/g;
        this.value = this.value.replace(allowedChars, '');
        monogramValue[index] = this.value.toUpperCase();
        if (this.value.length) {
          const nextInput = monogramInputs[index + 1 >= monogramInputs.length ? 0 : index + 1];
          nextInput.focus();
          nextInput.select();
        }
        enableAddMonogramBtn();
        showRemoveMonogramBtn();
        typeToPlaceholder();
      });
    });
  }

  addMonogramBtn.addEventListener('click', () => {
    const bundleParent = atcFormMonogram.parentElement.querySelector('.product-variant-id').value;
    const bundleId = new Date().valueOf();
    customizationMonogram.classList.remove('hidden');
    customizationPlaceholder.textContent = monogramValue.join('');
    atcFormMonogram.innerHTML = `
      <input type="hidden" name="properties[_Monogram]" value="${monogramValue.join('')}">
      <input type="hidden" name="properties[_bundleId]" value="${bundleId}">
      <input type="hidden" name="properties[_bundleParent]" value="${bundleParent}">
      <input type="hidden" name="properties[_hashParent]" value="${bundleId}">
      <input type="hidden" name="properties[_customized]" value="Monogram">      
      <input type="hidden" name="items[0][id]" value="${atcFormMonogram.dataset.monogramId}">
      <input type="hidden" name="items[0][quantity]" value="1">
      <input type="hidden" name="items[0][properties][Monogram]" value="${monogramValue.join('')}">
      <input type="hidden" name="items[0][properties][_bundleId]" value="${bundleId}">
      <input type="hidden" name="items[0][properties][_hashChild]" value="${bundleId}">
      <input type="hidden" name="items[0][properties][_excludeFromReturns]" value="true">
    `;
  });

  removeMonogramBtn.addEventListener('click', () => {
    resetAll();
  });

  clearMonogramBtn.addEventListener('click', () => {
    resetAll();
  });

  resetMonogramBtn.addEventListener('click', () => {
    resetAll();
  });
}

function enableAddMonogramBtn() {
  if (monogramValue.length) {
    addMonogramBtn.removeAttribute('disabled');
  } else {
    addMonogramBtn.addAttribute('disabled', true);
  }
}

function showRemoveMonogramBtn() {
  if (monogramValue.length) {
    removeMonogramBtn.classList.remove('hidden');
  } else {
    removeMonogramBtn.classList.add('hidden');
  }
}

function typeToPlaceholder() {
  monogramPlaceholder.textContent = monogramValue.join('');
}

function resetAll() {
  monogramValue.length = 0;
  monogramInputs.forEach((input) => {
    input.value = '';
  });
  atcFormMonogram.innerHTML = '';
  addMonogramBtn.removeAttribute('disabled');
  removeMonogramBtn.classList.add('hidden');
  customizationMonogram.classList.add('hidden');
  typeToPlaceholder();
}

init();
})();